import React, { useEffect, useRef } from 'react';
import cx from 'classnames';
import wrapStore from '@src/utils/wrap-store';
import styles from './index.less';
import SixthPageStore from '@src/pages/main/components/sixth-page/store';
import BaseSwiper from '@src/components/swiper/base-swiper';
import Link from '@src/components/link';
import SilentVideo from '@src/components/silent-video';
/**
 * SecondPage
 * @param store {SixthPageStore}
 * @returns {JSX.Element}
 * @constructor
 */
const SixthPage = ({ store }) => {
  store.use();
  const videoWrapper = useRef();

  useEffect(
    () => {
      videoWrapper.current.querySelectorAll('.silent-video').forEach(video => {
        video.addEventListener('ended', () => {
          store.baseSwiperStore.goNext();
        });
      });
    },
    [store.isActive]
  );

  // swiper滚动到对应位置,对应位置才播放，其余位置暂停播放，且进度调归0
  useEffect(
    () => {
      videoWrapper.current.querySelectorAll('.silent-video').forEach(video => {
        video.pause();

        const index = +video.getAttribute('data-index');
        if (store.isActive && index === store.baseSwiperStore.activeIndex) {
          video.currentTime = 0;
          video.muted = true;
          video.play();
        }
      });
    },
    [store.baseSwiperStore.activeIndex, store.isActive]
  );

  const renderSwiper = () => {
    if (store.featureList) {
      return store?.featureList?.map((item, index) => {
        return (
          <div key={item.feature_id} className={styles.featurePartItem}>
            <div data-name="纹理背景" className={styles.textureBg} />
            <SilentVideo
              autoPlay={false}
              className={cx(styles.kvVideo, 'silent-video')}
              cover={item.video_cover}
              src={item.video_url}
              muted={true}
              data-index={index}
            />
            <img className={styles.title} src={item.title_img} alt={item.title} />
          </div>
        );
      });
    }
  };

  const renderPaginator = () => {
    return store?.featureList?.map((item, key) => {
      return (
        <Link
          className={cx(styles.paginatorItem, key === store.baseSwiperStore.activeIndex && styles.paginatorItemActive)}
          onClick={() => store.baseSwiperStore.onChange(key)}
          key={key}
        />
      );
    });
  };

  return (
    <div className={cx(styles.root)}>
      <div className={styles.container}>
        <div className={styles.baseSwiperBox} ref={videoWrapper}>
          {store?.featureList?.length > 0 && <BaseSwiper store={store.baseSwiperStore}>{renderSwiper()}</BaseSwiper>}
          <div className={styles.swiperBottomBox}>
            <div className={styles.paginatorBox}>{renderPaginator()}</div>
            <div className={styles.swiperBtnBox}>
              <Link className={cx(styles.prevBtn, styles.swiperBtn)} onClick={store.baseSwiperStore.goPrev} />
              <Link className={cx(styles.nextBtn, styles.swiperBtn)} onClick={store.baseSwiperStore.goNext} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default wrapStore(SixthPage, SixthPageStore);
